// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"5":"5ca42ffa","422":"522b8eb7","452":"0de69fdc","514":"73be821f","521":"ab7e773b","825":"49d8f1b3","897":"0c0b02f5"}[chunkId] + ".js";
};